import { safeLocalStorage } from 'publisher/utils/safe-local-storage'
import { useEffect } from 'react'
import { FormFieldInterface } from 'src/shared/entities/form/form-field-sub-entity.schema'
import { useFormContext } from '../context/form-context'

interface UseFormFieldProps {
  fieldSubEntity: FormFieldInterface
}

const getFormSafeLocalStorageKey = (slug: string) => `form-${slug}`

export const useFormField = ({ fieldSubEntity }: UseFormFieldProps) => {
  const { fieldsValues, fieldsErrors, setFieldsValues, setFieldsErrors } =
    useFormContext()

  const slug = fieldSubEntity.slug
  const value = fieldsValues[slug]
  const valueFromStorage = safeLocalStorage.getItem(
    getFormSafeLocalStorageKey(slug),
  )

  useEffect(() => {
    if (slug) {
      if (valueFromStorage) {
        setFieldsValues(prev => ({ ...prev, [slug]: valueFromStorage }))
      }
    }
  }, [slug])

  return {
    value,
    onChange: (value: string | undefined) => {
      if ((!valueFromStorage || value) && slug) {
        safeLocalStorage.setItem(getFormSafeLocalStorageKey(slug), value ?? '')
      }
      setFieldsValues(prev => ({ ...prev, [slug]: value }))
      setFieldsErrors(prev => ({ ...prev, [slug]: [] }))
    },
    errors: fieldsErrors[slug] || [],
  }
}
